/**
 * CoLab Animations Module
 * Scroll анімації та typed ефект
 */

function init() {
    initScrollAnimations();
    initTypedAnimations();
    initStaggerAnimations();
}

// ============================================
// Scroll Animations (AOS alternative)
// ============================================
function initScrollAnimations() {
    const animatedElements = document.querySelectorAll('[data-animate]');

    if (!animatedElements.length) return;

    const observer = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
            if (entry.isIntersecting) {
                const delay = entry.target.getAttribute('data-animate-delay') || 0;

                setTimeout(function() {
                    entry.target.classList.add('is-animated');
                }, parseInt(delay));

                observer.unobserve(entry.target);
            }
        });
    }, {
        threshold: 0.1,
        rootMargin: '0px 0px -50px 0px'
    });

    animatedElements.forEach(function(el) {
        observer.observe(el);
    });
}

// ============================================
// Typed Animation on Scroll
// ============================================
function initTypedAnimations() {
    const typedElements = document.querySelectorAll('[data-typed]');

    if (!typedElements.length) return;

    typedElements.forEach(function(element) {
        const originalText = element.textContent.trim();
        const speed = parseInt(element.getAttribute('data-typed-speed')) || 50;
        const delay = parseInt(element.getAttribute('data-typed-delay')) || 0;

        // Prepare element
        element.innerHTML = '<span class="typed-text"></span><span class="typed-cursor">|</span>';
        element.classList.add('typed-ready');

        const textSpan = element.querySelector('.typed-text');

        // Observer for scroll trigger
        const observer = new IntersectionObserver(function(entries) {
            entries.forEach(function(entry) {
                if (entry.isIntersecting) {
                    setTimeout(function() {
                        typeText(textSpan, originalText, speed, function() {
                            element.classList.add('typed-complete');
                        });
                    }, delay);

                    observer.unobserve(entry.target);
                }
            });
        }, {
            threshold: 0.3,
            rootMargin: '0px 0px -100px 0px'
        });

        observer.observe(element);
    });
}

function typeText(element, text, speed, callback) {
    let index = 0;

    function type() {
        if (index < text.length) {
            const char = text[index];
            element.textContent += char;
            index++;
            setTimeout(type, speed);
        } else if (callback) {
            callback();
        }
    }

    type();
}

// ============================================
// Stagger Animations for lists
// ============================================
function initStaggerAnimations() {
    const staggerElements = document.querySelectorAll('[data-animate-stagger]');

    if (!staggerElements.length) return;

    const observer = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
            if (entry.isIntersecting) {
                entry.target.classList.add('is-animated');
                observer.unobserve(entry.target);
            }
        });
    }, {
        threshold: 0.2,
        rootMargin: '0px 0px -50px 0px'
    });

    staggerElements.forEach(function(el) {
        observer.observe(el);
    });
}

// ============================================
// Counter Animation
// ============================================
function animateCounter(element, start, end, duration) {
    start = start || 0;
    duration = duration || 2000;

    let startTime = null;
    const diff = end - start;

    function step(timestamp) {
        if (!startTime) startTime = timestamp;
        let progress = Math.min((timestamp - startTime) / duration, 1);

        // Easing function
        progress = 1 - Math.pow(1 - progress, 3);

        element.textContent = Math.floor(start + diff * progress);

        if (progress < 1) {
            requestAnimationFrame(step);
        }
    }

    requestAnimationFrame(step);
}

// ============================================
// Parallax Effect (CSS variables)
// ============================================
function initParallax() {
    const parallaxElements = document.querySelectorAll('[data-parallax]');

    if (!parallaxElements.length) return;

    function updateParallax() {
        const scrollY = window.pageYOffset;

        parallaxElements.forEach(function(el) {
            const speed = parseFloat(el.getAttribute('data-parallax')) || 0.5;
            const rect = el.getBoundingClientRect();
            const offset = (scrollY - rect.top - window.innerHeight / 2) * speed;
            el.style.setProperty('--parallax-offset', offset + 'px');
        });
    }

    window.addEventListener('scroll', throttle(updateParallax, 16), { passive: true });
    updateParallax();
}

// Simple throttle helper (assuming CoLab.Utils.throttle doesn't exist in ES6 version)
function throttle(func, wait) {
    let timeout;
    let previous = 0;

    return function() {
        const now = Date.now();
        const remaining = wait - (now - previous);
        const context = this;
        const args = arguments;

        if (remaining <= 0 || remaining > wait) {
            if (timeout) {
                clearTimeout(timeout);
                timeout = null;
            }
            previous = now;
            func.apply(context, args);
        } else if (!timeout) {
            timeout = setTimeout(function() {
                previous = Date.now();
                timeout = null;
                func.apply(context, args);
            }, remaining);
        }
    };
}

export const Animations = {
    init,
    animateCounter,
    initParallax
};
